var _path, _path2, _g, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinanceAuditBoardPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 68,
    viewBox: "0 0 61 68",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.664 13.8198L19.9122 8.6404C18.2796 8.41032 16.7647 9.54438 16.503 11.171C13.8843 27.4467 10.8578 37.4643 3.55133 51.8936C2.62209 53.7288 3.73118 55.9514 5.76298 56.2688L42.6351 62.0283C43.9367 62.2316 45.2249 61.5604 45.7944 60.3722C52.781 45.7956 55.8006 35.4213 59.1818 17.3185C59.4937 15.6486 58.3472 14.057 56.664 13.8198Z",
    fill: "url(#paint0_linear_4691_18680)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6582 11.8198L18.9063 6.6404C17.2738 6.41032 15.7588 7.54438 15.4971 9.17101C12.8785 25.4467 9.85193 35.4643 2.54547 49.8936C1.61623 51.7288 2.72532 53.9514 4.75712 54.2688L41.6292 60.0283C42.9308 60.2316 44.219 59.5604 44.7885 58.3722C51.7751 43.7956 54.7948 33.4213 58.1759 15.3185C58.4878 13.6486 57.3413 12.057 55.6582 11.8198Z",
    fill: "url(#paint1_linear_4691_18680)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4691_18680)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.3307,
    cy: 39.0234,
    rx: 11.568,
    ry: 11.5,
    fill: "url(#paint2_linear_4691_18680)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6488 39.0234C47.6488 44.6774 43.0362 49.2734 37.3307 49.2734C31.6253 49.2734 27.0127 44.6774 27.0127 39.0234C27.0127 33.3695 31.6253 28.7734 37.3307 28.7734C43.0362 28.7734 47.6488 33.3695 47.6488 39.0234Z",
    stroke: "#DDEBF6",
    strokeWidth: 2.5,
    shapeRendering: "crispEdges"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5124 56.9418C52.2957 57.7206 53.562 57.7168 54.3408 56.9335C55.1195 56.1501 55.1158 54.8838 54.3324 54.1051L51.5124 56.9418ZM42.4591 47.9418L51.5124 56.9418L54.3324 54.1051L45.2792 45.1051L42.4591 47.9418Z",
    fill: "#DDEBF6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4691_18680",
    x: 21.7627,
    y: 24.5234,
    width: 31.136,
    height: 31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4691_18680"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4691_18680",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4691_18680",
    x1: 19.2243,
    y1: 9.52344,
    x2: 52.1003,
    y2: 79.6731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68263,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906518,
    stopColor: "#DDEBF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4691_18680",
    x1: 18.2184,
    y1: 7.52344,
    x2: 46.6156,
    y2: 65.6561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68263,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906518,
    stopColor: "#DDEBF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4691_18680",
    x1: 54.4313,
    y1: 50.5234,
    x2: 25.8632,
    y2: 31.8695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFD7EC",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.07
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceAuditBoardPage);
export default __webpack_public_path__ + "static/media/financeAudit-board-page.55a2fa61708a9b880e7fa8f9d56c991f.svg";
export { ForwardRef as ReactComponent };